module.exports = __webpack_public_path__ + "static/media/EXERGUECHAP3.7b6602dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/EXERGUECHAP3.png
// module id = 252
// module chunks = 0